// Cookie names are fixed by the API (modules/identity/infrastructure/auth.py).
export const SESSION_COOKIE = "__Host-mozaic_browser";
export const CSRF_COOKIE = "__Host-mozaic_csrf";
export const CSRF_HEADER = "X-CSRF-Token";
